import { handleActions } from 'redux-actions';
import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';
import {
  biFormsByCategorySuccess,
  biFormsByDateSuccess,
  biFormsByFormSuccess,
  biFormsBySiteAndDateSuccess,
  setLoadingState,
} from './actions';

export default handleActions(
  {
    [biFormsBySiteAndDateSuccess](state, { payload }) {
      return {
        ...state,
        bySiteAndDate: payload,
      };
    },
    [biFormsByDateSuccess](state, { payload }) {
      return {
        ...state,
        byDate: payload,
      };
    },
    [biFormsByCategorySuccess](state, { payload }) {
      return {
        ...state,
        byCategory: payload,
      };
    },
    [biFormsByFormSuccess](state, { payload }) {
      return {
        ...state,
        byForm: payload,
      };
    },
    [setLoadingState](state, { payload }) {
      return {
        ...state,
        loading: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
